<section class="login-registration-page">
  <form *ngIf="form" class="login-registration-form" [formGroup]="form" (ngSubmit)="register()">
    <p class="main-form-title" data-test-id="registration-form-title">
      {{ 'SIGN_UP_FORM_TEXT' | translate }}
    </p>
    <div class="mb-3" data-test-id="wrap-registration-form-email">
      <label class="form-label" for="email"> {{ 'SIGN_UP_FORM_EMAIL_LABEL' | translate }} * </label>
      <input
        class="form-control"
        [ngClass]="{ 'is-invalid': isFieldInvalid('email') }"
        type="email"
        formControlName="email"
        id="email"
        data-test-id="registration-form-email"
        placeholder="{{ 'SIGN_UP_FORM_EMAIL_INPUT_PLACEHOLDER' | translate }}"
      />
      <small class="invalid-feedback" data-test-id="registration-form-email-error">
        {{ getErrorDescriptionId('email') | translate }}
      </small>
    </div>
    <div #selectedMenu="ngbDropdown" ngbDropdown class="mb-3" data-test-id="wrap-registration-form-account-type">
      <label class="form-label" for="accountType"> {{ 'SIGN_UP_ACCOUNT_TYPE_SELECT_LABEL' | translate }} * </label>
      <button
        type="button"
        (click)="selectedMenu.isOpen() ? selectedMenu.close() : selectedMenu.open()"
        class="dropdown-button d-grid border-0 w-100 p-0"
        [ngClass]="{ 'is-invalid': !selectedItem && form.touched }"
      >
        <input
          #dropDown
          id="accountType"
          [ngClass]="{ 'is-invalid': !selectedItem && form.touched }"
          data-test-id="registration-form-account-type"
          formControlName="accountType"
          class="form-control form-select disabled-dropdown"
          [value]="selectedItem"
          type="text"
          ngbDropdownAnchor
          readonly
          placeholder="{{ 'SIGN_UP_ACCOUNT_TYPE_SELECT_PLACEHOLDER' | translate }}"
        />
      </button>
      <small class="invalid-feedback" data-test-id="registration-form-account-type-error">
        {{ 'SIGN_UP_ACCOUNT_TYPE_SELECT_ERROR' | translate }}
      </small>
      <div ngbDropdownMenu aria-labelledby="dropdownMenuAccount" class="dropDownMenu">
        <ng-container *ngFor="let item of accountTypeOptions; index as i">
          <button
            ngbDropdownItem
            type="button"
            [value]="item"
            [attr.data-test-id]="'account-option-' + i"
            (click)="selectCurrentValue(item)"
          >
            {{ item | translate }}
          </button>
        </ng-container>
      </div>
    </div>
    <div class="mb-3" data-test-id="wrap-registration-form-alias" *ngIf="selectedItem === accountType.INDIVIDUAL">
      <label class="form-label" for="alias"> {{ 'SIGN_UP_FORM_ALIAS_LABEL' | translate }} * </label>
      <input
        class="form-control"
        [ngClass]="{ 'is-invalid': isFieldInvalid('alias') }"
        type="text"
        formControlName="alias"
        id="alias"
        data-test-id="registration-form-alias"
        placeholder="{{ 'SIGN_UP_FORM_ALIAS_INPUT_PLACEHOLDER' | translate }}"
      />
      <small class="invalid-feedback" data-test-id="registration-form-alias-error">
        {{ getErrorDescriptionId('alias') | translate }}
      </small>
    </div>
    <div
      class="mb-3"
      data-test-id="wrap-registration-form-organization-name"
      *ngIf="selectedItem === accountType.ORGANIZATION"
    >
      <label class="form-label" for="organizationName">
        {{ 'SIGN_UP_FORM_ORGANIZATION_NAME_LABEL' | translate }} *
      </label>
      <input
        class="form-control"
        [ngClass]="{ 'is-invalid': isFieldInvalid('organizationName') }"
        type="text"
        formControlName="organizationName"
        id="organizationName"
        data-test-id="registration-form-organization-name"
        placeholder="{{ 'SIGN_UP_FORM_ORGANIZATION_NAME_INPUT_PLACEHOLDER' | translate }}"
      />
      <small class="invalid-feedback" data-test-id="registration-form-organization-name-error">
        {{ getErrorDescriptionId('organizationName') | translate }}
      </small>
    </div>
    <div class="password-group" data-test-id="wrap-registration-form-password">
      <app-eye-password
        [form]="form"
        [id]="'password'"
        [controlName]="'password'"
        [dataTestId]="'registration-form-password'"
        [showValidMark]="true"
        [errorTexting]="texting('registration-form-password-error', 'FIELD_PASSWORD_ERROR')"
        [validTexting]="texting('registration-form-valid-password', 'VALID_LOOKS_GOOD')"
        [instructionTexting]="texting('password-instruction', 'FORM_PASSWORD_INPUT_INSTRUCTION')"
        [placeholder]="'FORM_PASSWORD_INPUT_PLACEHOLDER'"
        [inputLabel]="'FORM_PASSWORD_LABEL'"
        [invalid]="isFieldInvalid('password')"
        [formValid]="isFieldValid('password')"
      ></app-eye-password>
    </div>
    <div class="password-group" data-test-id="wrap-registration-form-repeat-password">
      <app-eye-password
        [form]="form"
        [id]="'repeat-password'"
        [controlName]="'repeatPassword'"
        [dataTestId]="'registration-form-repeat-password'"
        [showValidMark]="true"
        [validTexting]="texting('registration-form-valid-password', 'VALID_LOOKS_GOOD')"
        [errorTexting]="texting('registration-form-repeat-password-error', repeatPasswordTextError)"
        [placeholder]="'FORM_REPEAT_PASSWORD_INPUT_PLACEHOLDER'"
        [inputLabel]="'FORM_REPEAT_PASSWORD_LABEL'"
        [invalid]="isRepeatPasswordFieldInvalid()"
        [formValid]="isRepeatPasswordFieldValid()"
      ></app-eye-password>
    </div>
    <div class="form-check" data-test-id="wrap-checkbox">
      <input
        class="form-check-input"
        [ngClass]="{ 'is-invalid': isFieldInvalid('agreeCheck') }"
        type="checkbox"
        formControlName="agreeCheck"
        id="agreeCheck"
        data-test-id="registration-form-agree-check"
      />
      <label class="form-label" for="agreeCheck" data-test-id="agree-check-label">
        <span
          [innerHtml]="'SIGN_UP_FORM_AGREE_CHECK' | translate: { privacyPolicyLink: '/terms' }"
          data-test-id="registration-form-agree-check-links"
        ></span
        ><span>*</span>
      </label>
      <small class="form-text text-muted required-hint d-block"> * - {{ 'REQUIRED_FIELD_HINT' | translate }} </small>
    </div>
    <button
      appLongOperation
      appDebounceClick
      (debounceClick)="register()"
      [debounceTime]="DEBOUNCE_TIME"
      class="btn btn-primary text-white"
      type="submit"
      data-test-id="registration-form-register-btn"
    >
      {{ 'SIGN_UP_FORM_SUBMIT_BTN' | translate }}
    </button>
  </form>
</section>
